export default __webpack_public_path__ + "static/media/meta-tag-icon.7b39d1ab.svg";